import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';
import { DatagridConfigurable } from 'shared/react-admin/Datagrids';

const ACTION_COLUMN_WIDTH = 44;

const stickyShadow = {
  content: '""',
  position: 'absolute' as const,
  top: 0,
  left: -4,
  width: 4,
  height: '100%',
  boxShadow: '1px 0 3px rgba(0, 0, 0, 0.1)',
};

const stickyCellStyles = {
  position: 'sticky' as const,
  right: 0,
  width: ACTION_COLUMN_WIDTH,
  borderBottom: '1px solid #EBEBEB',
  backgroundColor: 'inherit',
  '&::after': stickyShadow,
};

export const DatagridStyled = styled(DatagridConfigurable)(() => ({
  '& .MuiTableRow-root:hover': {
    backgroundColor: '#F5F5F5!important',
  },
  th: {
    '&:last-child': {
      ...stickyCellStyles,
      backgroundColor: '#FAFAFA!important',
    },
  },
  td: {
    '&:last-child': {
      ...stickyCellStyles,
      padding: '12px 4px 12px 6px',
    },
  },
}));

export const ContainerStyled = styled(Box)({
  overflowX: 'visible',
  overflowY: 'visible',
  '& .RaBulkActionsToolbar-root': {
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 10,
    width: 'fit-content',
    backgroundColor: 'background.paper',
  },
  '& .RaDatagrid-tableWrapper': {
    overflowX: 'auto',
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 250px)',
  },
});

export const DatagridResizableStyled = styled(DatagridStyled)({
  overflowX: 'visible',
  overflowY: 'visible',
  '& > div:has(> .MuiToolbar-root)': {
    position: 'static !important',
    top: 'auto !important',
    left: 'auto !important',
    zIndex: 'auto !important',
  },
  '& .RaDatagrid-thead': {
    position: 'sticky',
    top: 0,
    zIndex: 2,
  },
  '& .RaDatagrid-headerCell': {
    position: 'relative',
    top: 'auto',
    zIndex: 'auto',
    overflow: 'visible !important',
    backgroundColor: '#FAFAFA !important',
  },
  '& tbody .MuiTableCell-root:not(:last-child)': {
    borderRight: '1px solid #EBEBEB',
  },
  '& [data-resizable]': {
    right: '-8px !important',
    zIndex: '30 !important',
    '&:hover': {
      opacity: 1,
    },
  },
});
